// extracted by mini-css-extract-plugin
export default {"form":"Login_form__m95NP","forgot-password":"Login_forgot-password__g8+XV","GoogleButton":"Login_GoogleButton__uVdGH"};